var grecaptchaOnloadCallback = function (e) {

    Array.prototype.forEach.call(
        document.getElementsByClassName('form-recaptha'), function (element) {

            var formElement = element;

            grecaptcha.render(formElement.getElementsByClassName('btn-submit')[0], {
                'sitekey': formElement.dataset.recaptha,
                'callback': function callback(token) {
                    var elm = formElement;
                    return new Promise(function (resolve, reject) {

                        if (typeof $(elm).data('grecaptcha-callback') != 'undefined') {
                            window[$(elm).data('grecaptcha-callback')](elm);
                        }
                        else {
                            HTMLFormElement.prototype.submit.call(elm);
                        }

                        resolve();
                    });
                }
            });
        });
}

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function round(num) {
    return Math.round((num + 2.220446049250313e-16) * 100) / 100;
}

function getVat(vatRate) {
    return config.webshop.vat[vatRate];
}

function formatPrice(price) {

    return config.webshop.currency == 'euro'
        ? parseFloat(price).toFixed(2).replace('.', ',')
        : parseFloat(price).toFixed(2);
}

function normalizePrice(price) {

    //remove all non digit chars except . and ,
    price = price.replace(/\s|[a-zA-Z]+/gi, '');

    //number contains more then 1 .
    if ((price.match(new RegExp(".", "g")) || []).length > 1 &&
        (price.match(new RegExp(",", "g")) || []).length == 0) {
        price = price.replace(/\./gi, '');
    }

    //number contains more then 1 ,
    if ((price.match(new RegExp(",", "g")) || []).length > 1 &&
        (price.match(new RegExp(".", "g")) || []).length == 0) {
        price = price.replace(/\,/gi, '');
    }

    //number contains atleast 1 , and 1 .
    if ((price.match(new RegExp(".", "g")) || []).length > 0 &&
        (price.match(new RegExp(",", "g")) || []).length > 0) {


        if (price.replace(/\d/gi, '').charAt(0) == '.') {
            price = price.replace(/\./gi, '');
        } else {
            price = price.replace(/\,/gi, '');
        }
    }

    //replace , by .
    return parseFloat(price.replace(/\,/gi, '.'));
}

function getPrice(price, vatRate) {

    let val, vat;
    if (config.webshop.type == 'B2C') {

        if (vatRate == '0' || vatRate == null) {
            val = parseFloat(price);
        } else {
            val = parseFloat(price) * ((getVat(vatRate) / 100) + 1);
        }

    } else {
        val = parseFloat(price);
    }

    return number_format(val, 2, ',', '');
}

function getCurrency() {

    return config.webshop.currency == 'euro'
        ? '&euro;'
        : (config.webshop.currency == 'pound'
            ? '₤'
            : '$');
}

function getLocalePrice(price, vatRate = null) {
    let sumPrefix = '',
        sumSuffix = '',
        sum = getPrice(price, vatRate),
        currency = getCurrency();

    // Show currency sign before sum.
    if (config.webshop.prices.display.show_currency_sign == 1 &&
        config.webshop.prices.display.currency_sign_placement == 'before') {
        sumPrefix = currency+' ';
    }

    // Show currency sign after sum.
    if (config.webshop.prices.display.show_currency_sign == 1 &&
        config.webshop.prices.display.currency_sign_placement == 'after') {
        sumSuffix = ' '+currency;
    }

    // Hide zero decimals from price.
    if (config.webshop.prices.display.show_zero_decimals == 0) {
        sum = sum.replace(',00',',-');
    }

    return sumPrefix+sum+sumSuffix;
}

function AddAnalyticsCookies() {

    let date = new Date(),
        elm = document.getElementById('ck-notification-popup');

    date.setTime(date.getTime() + 31536000000);
    document.cookie = "AnalyticsCookies=Accepted; expires=" + date.toGMTString() + ";path=/;";
    elm.parentNode.removeChild(elm);
}

function DenyAnalyticsCookies() {

    let date = new Date(),
        elm = document.getElementById('ck-notification-popup');

    date.setTime(date.getTime() + 31536000000);
    document.cookie = "AnalyticsCookies=Declined; expires=" + date.toGMTString() + ";path=/;";
    elm.parentNode.removeChild(elm);
}

function AddOldBrowserCookies() {

    let date = new Date(),
        choice = 'Accepted';

    date.setTime(date.getTime() + 31536000000);
    document.cookie = "oldBrowser=" + choice + "; expires=" + date.toGMTString() + ";path=/;";
}

function getDomain() {
    if (config.global.platform == 'SDML' &&
        config.global.language_in_slug == '1') {

        if (config.global.default_language == config.global.language) {
            return config.domain;
        } else {
            return config.domain + '/' + config.global.language;
        }
    }

    return config.domain;
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function preventDefault(e) {
    if (e.preventDefault) {
        e.preventDefault();
    }
    else {
        e.returnValue = false;
    }
}

// function setLoading(selector) {

//     let elm = selector;

//     if ($(selector).find('.loading').length == 0) {
//         $(selector).append('<div class="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>');

//         setTimeout(function () {
//             $(elm + ' .loading').remove();
//         }, 5000);
//     }
//     else {
//         $(selector).find('.loading').remove();
//     }
// }

function setLoading(selector, state = 'add') {

    if (state == 'add' && $(selector).find('.loading').length == 0) {
        var loading = '<div class="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>'
        $(selector).append(loading);
    }
    else if (state == 'remove') {
        $(selector).find('.loading').remove();
    }
}

function setOverlay(selector, extra = null) {


    if ($(selector + ' .overlay-gradient').length == 0) {

        let extraClass = '';
        if (extra != null) {
            extraClass = extra + '-gradient';
        }

        $(selector).append('<div class="overlay-gradient ' + extraClass + '"></div>');
    } else {
        $(selector + ' .overlay-gradient').remove();
    }
}

function inputDigits(amount) {
    amount = amount.toString().replace('.', '').replace(/\D/, '');
    if (amount == '') {
        amount = 1;
    }

    return amount;
}

$(document).ready(function(){

    new ProductsFavorite();

    new ProductsUpsell();

    $('a.scrollto[href*="#"]:not([href="#"])').click(function() {
        let headerHeight = 0;

        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            
            if (target.length) {

                headerHeight = $('header').height();

                $('html,body').animate({
                    scrollTop: target.offset().top - headerHeight
                }, 1000);

                return false;
            }
        }
    });


    if ($('.carousel-usps').length > 0) {
        $('.carousel-usps').owlCarousel({
            items: 1,
            slideBy: 1,
            margin: 15,
            autoplay: true,
            autoplayTimeout: 3000,
            loop: true,
            dots: false,
            nav: false,
            responsive: {
                992: {
                    items: $('.block-usp-home').length,
                    margin: 15,
                    touchDrag: false,
                    pullDrag: false,
                    mouseDrag: false,
                    autoplay: false,
                    loop: false,
                }
            }
        });
    }
    
    $('.input-number').on('keyup', function() {
        $(this).val($(this).val().replace(/[^\d]/,''));
    });

    $('.ck-accept').on('click', function(e) {
        AddAnalyticsCookies();
    });

    $('.ck-deny').on('click', function(e) {
        DenyAnalyticsCookies();
    });
    
    $('[data-toggle="tooltip"]').tooltip();

    $('.singular-or-plural').each(function() {

        $(this).html(parseInt($(this).data('counter')) > 1
            ? $(this).data('counter')+" "+$(this).data('text-plural') + " "
            : $(this).data('counter')+" "+$(this).data('text-singular') + " "
        );
    });

    $('.socialmedia').on('click', function(e) {

        e.preventDefault();

        window.open($(this).data('url'), 'popup', 'width=600,height=600'); 
    });

    // Password-checker, click on the eye and toggle password input field.
    $('body').on('click', '.password-checker', function(e){
        let elem = $(this).parent().find('input');
        if(elem.attr('type') == 'password') {
            elem.attr('type','text');
        } else {
            elem.attr('type','password');
        }
    });

    let widgetSlideIn = '65px';
    let widgetSlideOut = '85px';

    if ($(window).width() >= 768) {
        widgetSlideIn = '95px';
        widgetSlideOut = '115px';
    }

    $('.widget-contactperson img').on('click', function(){
        if($('.widget-contactperson .popup').hasClass('open')) {
            $('.widget-contactperson .popup', function(){
                $('.widget-contactperson .popup').removeClass('open').css('opacity',0).css('right',widgetSlideIn).fadeOut(function(){
                    $('.widget-contactperson .popup').addClass('d-none');
                });
            });
        } else {
            $('.widget-contactperson .popup').removeClass('d-none').fadeIn(function(){
                $('.widget-contactperson .popup').css('opacity',1).css('right',widgetSlideOut).addClass('open');
            });
        }
    });
    
    $('.widget-contactperson .popup i.fa-times').on('click', function(){
        $('.widget-contactperson .popup', function(){
            $('.widget-contactperson .popup').removeClass('open').css('opacity',0).css('right',widgetSlideIn).fadeOut(function(){
                $('.widget-contactperson .popup').addClass('d-none');
            });
        });
    });
});